<template>
	<main class="container mx-auto shadow bg-white -my-2 rounded-lg overflow-hidden">
		<section class="relative bg-cover bg-left pb-64 sm:pb-72 md:pb-96" :style="`background-image: url('${require('@/assets/image/Referral-Header.jpg')}')`">
			<div class="w-full text-center text-white px-2 py-4 leading-tight sm:py-6" style="background: linear-gradient(#1C1C1C, #1C1C1C99 90%, transparent);">
				<h1 class="text-2xl font-bold leading-none tracking-wide pb-2 border-b-2 border-dish-red max-w-xs mx-auto sm:text-4xl sm:max-w-lg md:border-b-4 md:text-5xl md:max-w-2xl md:pb-6 lg:max-w-4xl lg:text-6xl">Share the DISH Outdoors <br> Entertainment Experience</h1>
				<p class="mt-2 italic text-xl mx-auto max-w-sm sm:text-2xl sm:max-w-lg md:text-3xl md:mt-4 md:max-w-2xl lg:max-w-3xl lg:text-4xl">Give your friends <span class="font-semibold">$30 off</span> and we'll reward you with <span class="font-semibold">$30</span> for each friend who purchases.</p>
			</div>
		</section>

		<section class="bg-dish-red py-5 px-4 sm:py-8 md:py-10 lg:px-6 xl:px-12">
			<div class="space-y-4 sm:space-y-6 md:space-y-8 lg:flex lg:justify-center lg:space-y-0 lg:space-x-4 xl:space-x-12">
				<ApplyStep class="mx-auto lg:mx-0" :number="1" text="Request your link below." />
				<ApplyStep class="mx-auto lg:mx-0" :number="2" text="Share with your friends." />
				<ApplyStep class="mx-auto lg:mx-0" :number="3" text="Get $30 for each purchase using your link." />
			</div>

			<h1 class="mt-6 text-white text-center leading-7 text-2xl font-medium tracking-wide max-w-md mx-auto sm:max-w-full sm:mt-8 sm:font-semibold sm:text-3xl sm:leading-tight md:text-4xl lg:mt-10 lg:text-3xl">Enter your email and order number for your custom referral link.</h1>

			<form v-if="!isSuccessful" class="mt-4 sm:mt-5 lg:mt-6 mx-auto max-w-md space-y-2 sm:space-y-3 md:space-y-4 lg:max-w-2xl lg:space-y-0 lg:flex lg:justify-center" @submit.prevent="apply">
				<input v-model="email" class="w-full rounded bg-white py-1 px-4 text-xl sm:py-2 " required autocomplete="email" placeholder="Email" type="email">
				<input v-model="orderNumber" class="w-full rounded bg-white py-1 px-4 text-xl sm:py-2 lg:my-0 lg:w-32 lg:ml-5" required placeholder="Order #" type="number">
				<button class="w-full bg-white text-dish-red rounded py-1 px-4 font-semibold text-lg sm:py-2 lg:w-80 lg:ml-12 lg:font-bold" type="submit" :class="{ spin: isLoading }">Get My Link</button>
			</form>
			<div v-else class="mt-4 sm:mt-5 lg:mt-6">
				<div class="border-t-2 border-white max-w-xs mx-auto sm:max-w-md md:border-t-4" />
				<p class="text-center text-white font-medium text-3xl tracking-wide leading-tight pt-4 sm:pt-6 md:text-4xl md:font-semibold">Your link will be sent to the email provided shortly.</p>
			</div>

			<p v-if="isInvalid" class="text-center text-white pt-2 font-medium sm:text-2xl md:font-semibold md:pt-4 lg:text-3xl">We had an issue with your submission. Try again later.</p>

			<p class="mt-8 mx-auto text-center text-xs text-white opacity-75 max-w-sm sm:max-w-xl md:max-w-2xl lg:max-w-4xl">Eligibility is based on a purchase made from DISHForMyRV validated through an order number. A unique link must be requested to participate. For each referral using your unique link that results in a purchase, you will be rewarded with a $30 gift card that will be issued within 45 days of that purchase and mailed within 4-6 weeks. Rewards are subject to change. Certificate and points are nonrefundable, not redeemable for cash, nontransferable and may not be combined with other reward offers.  All prices, fees, packages, charges, features, functionality and programming subject to change without notice.</p>
		</section>
	</main>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	import ApplyStep from '@/components/ApplyStep.vue'

	import { useApplyToProgram, useRecordVisits } from '../composables/useBackend'

	export default defineComponent({
		components: {
			ApplyStep,
		},

		setup() {
			useRecordVisits()

			const {
				email,
				orderNumber,
				isStatus,
				apply,
			} = useApplyToProgram()

			return {
				email,
				orderNumber,
				isInvalid: isStatus('Invalid'),
				isLoading: isStatus('Loading'),
				isSuccessful: isStatus('Completed'),
				apply,
			}
		},
	})
</script>

<style scoped>
	input::placeholder {
		@apply text-gray-600;
	}

	input[type='number'] {
		-moz-appearance:textfield;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	.spin {
		@apply text-transparent relative !important;
	}

	.spin::after {
		@apply absolute border-4 border-dish-red w-6 h-6 rounded-full;

		content: ' ';
		left: calc(50% - .75rem);
		top: calc(50% - .75rem);
		border-color: #f0144644;
		border-top-color: #f01446;
		animation: spinning 1.5s ease-in-out 0s infinite;
	}

	@keyframes spinning {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(720deg);
		}
	}
</style>
